import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, styled } from '@mui/material';
import { Typography } from '@totalsoft/rocket-ui';
import WrappedLinearProgress from 'components/common/WrappedLinearProgress';

export const ValueContainer = styled(Grid, { shouldForwardProp: prop => !['error'].includes(prop) })(({ theme, error }) => ({
  border: `1px solid ${error ? theme.palette.error.main : theme.palette.grey[300]}`,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1),
  color: error ? theme.palette.error.main : 'inherit'
}));

export const AuxiliaryValueLabel = styled('span')(({ theme }) => ({
  color: theme.palette.grey[500]
}));

export const ThresholdLabel = styled(Typography, { shouldForwardProp: prop => !['error'].includes(prop) })(({ theme, error }) => ({
  fontSize: '12px',
  whiteSpace: 'break-spaces',
  color: error ? theme.palette.error.main : 'inherit'
}));

const ProductInfo = ({
  size,
  itemProps,
  computing,
  name,
  secondName,
  value,
  validationValue,
  itemsList,
  minValue,
  maxValue,
  minValueText,
  maxValueText
}) => {
  const [valueInvalid, setValueInvalid] = useState();
  const [minValueInvalid, setMinValueInvalid] = useState();
  const [maxValueInvalid, setMaxValueInvalid] = useState();

  useEffect(() => {
    let tmpValueInvalid = false;
    let tmpMinValueInvalid = false;
    let tmpMaxValueInvalid = false;

    if (validationValue != null && minValue != null && validationValue < minValue) {
      tmpValueInvalid = true;
      tmpMinValueInvalid = true;
    }
    if (validationValue != null && maxValue != null && validationValue > maxValue) {
      tmpValueInvalid = true;
      tmpMaxValueInvalid = true;
    }

    setValueInvalid(tmpValueInvalid);
    setMinValueInvalid(tmpMinValueInvalid);
    setMaxValueInvalid(tmpMaxValueInvalid);
  }, [validationValue, minValue, maxValue]);

  const createGridItem = (name, value, itemSize, idx) => {
    return (
      <Grid item id={idx} xs={itemSize}>
        <Grid container>
          {(name || secondName) && (
            <Grid item xs={12}>
              <span>{`${name && secondName ? name + ' ' : name}`}</span>
              <AuxiliaryValueLabel>{secondName}</AuxiliaryValueLabel>
            </Grid>
          )}
          {value !== undefined && value !== null && !computing && (
            <Grid item xs={12}>
              <Typography fontWeight='bold' variant='subtitle1'>
                {value}
              </Typography>
            </Grid>
          )}
          {computing && (
            <Grid item xs={12} mt={1}>
              <WrappedLinearProgress />
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Grid item xs={size} {...itemProps}>
        <ValueContainer container error={valueInvalid}>
          {itemsList && itemsList.length > 0
            ? itemsList.map((item, idx) => createGridItem(item.name, item.value, 12 / itemsList.length, idx))
            : createGridItem(name, value, 12, 0)}
        </ValueContainer>
        <Grid container>
          {minValueText && !computing && (
            <Grid item xs={maxValueText ? 6 : 12}>
              <ThresholdLabel error={minValueInvalid}>{minValueText}</ThresholdLabel>
            </Grid>
          )}
          {maxValueText && !computing && (
            <Grid item xs={minValueText ? 6 : 12}>
              <ThresholdLabel align='right' error={maxValueInvalid}>
                {maxValueText}
              </ThresholdLabel>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};

ProductInfo.propTypes = {
  size: PropTypes.number,
  itemProps: PropTypes.any,
  name: PropTypes.string,
  secondName: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validationValue: PropTypes.number,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  minValueText: PropTypes.string,
  maxValueText: PropTypes.string,
  computing: PropTypes.bool,
  itemsList: PropTypes.array
};

ProductInfo.defaultProps = {
  size: 6
};

export default ProductInfo;
